import {
  Companion_getInstance240fx64zw6f6d as Companion_getInstance,
  ContractorDisputefe9zenbw9zpq as ContractorDispute,
  NotResponsible5sod6b685ij0 as NotResponsible,
  Appealxiso3o25clbz as Appeal,
  RequestSiteVisit2qqplegjmdj5x as RequestSiteVisit,
  Accept3c5lxev9vmal1 as Accept,
  MoreInfo_instancelndi8wb3mxe1 as MoreInfo_instance,
  Handled19mgago2u0m72 as Handled,
  RemedyHandled1fest6c8tpi44 as RemedyHandled,
  Remedy2jczhqm350rbv as Remedy,
  Credit3h7kqwetoaiq0 as Credit,
  ClientResponsexqxw1r0z235j as ClientResponse,
  FileIncident88pwqv67k7mz as FileIncident,
  NeedsApproval209x3ip39ndz6 as NeedsApproval,
  Appeal_instance35tazwmyjzfwk as Appeal_instance,
  DisputeResolution3thfkwxak0ppb as DisputeResolution,
  NotResponsible_instance227dyeoudt4p as NotResponsible_instance,
} from './IncidentResponseType.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance,
  $serializer_getInstancet3nsskmepj66 as $serializer_getInstance_0,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
} from '../supportModels.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { joinToStringxqcavsxcmh4q as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function IncidentResponseTypeSerializable$Companion$$childSerializers$_anonymous__chekci() {
  return Companion_getInstance_1().k2a();
}
function IncidentResponseTypeSerializable$Companion$$childSerializers$_anonymous__chekci_0() {
  return Companion_getInstance().k2a();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, IncidentResponseTypeSerializable$Companion$$childSerializers$_anonymous__chekci);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n8f_1 = [tmp_1, lazy(tmp_2, IncidentResponseTypeSerializable$Companion$$childSerializers$_anonymous__chekci_0), null, null, null, null, null, null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.incidentResponse.IncidentResponseTypeSerializable', this, 11);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('concern', true);
        tmp0_serialDesc.a1b('raiseIssue', true);
        tmp0_serialDesc.a1b('fileDispute', true);
        tmp0_serialDesc.a1b('proposingResolution', true);
        tmp0_serialDesc.a1b('credit', true);
        tmp0_serialDesc.a1b('due', true);
        tmp0_serialDesc.a1b('proposal', true);
        tmp0_serialDesc.a1b('remedy', true);
        tmp0_serialDesc.a1b('accessInfo', true);
        tmp0_serialDesc.a1b('time', true);
        this.t9f_1 = tmp0_serialDesc;
      }
      u9f(encoder, value) {
        var tmp0_desc = this.t9f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().n8f_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s8f_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.t8f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t8f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.u8f_1 === false)) {
          tmp1_output.s14(tmp0_desc, 2, value.u8f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.v8f_1 === false)) {
          tmp1_output.s14(tmp0_desc, 3, value.v8f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.w8f_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.w8f_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.x8f_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance();
          var tmp_2 = value.x8f_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.y8f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), value.y8f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.z8f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_1(), value.z8f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.a8g_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, $serializer_getInstance_1(), value.a8g_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.b8g_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_0(), value.b8g_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.c8g_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), value.c8g_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u9f(encoder, value instanceof IncidentResponseTypeSerializable() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t9f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_0().n8f_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.z13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp15_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, $serializer_getInstance_1(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, $serializer_getInstance_1(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, $serializer_getInstance_0(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.z13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp15_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, $serializer_getInstance_1(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, $serializer_getInstance_1(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, $serializer_getInstance_0(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return IncidentResponseTypeSerializable().v9f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.t9f_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().n8f_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), get_nullable(tmp0_cached[1].f2()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable($serializer_getInstance_1()), get_nullable($serializer_getInstance_1()), get_nullable($serializer_getInstance_0()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var IncidentResponseTypeSerializableClass;
function IncidentResponseTypeSerializable() {
  if (IncidentResponseTypeSerializableClass === VOID) {
    class $ {
      constructor(type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time) {
        Companion_getInstance_0();
        concern = concern === VOID ? null : concern;
        raiseIssue = raiseIssue === VOID ? false : raiseIssue;
        fileDispute = fileDispute === VOID ? false : fileDispute;
        proposingResolution = proposingResolution === VOID ? false : proposingResolution;
        credit = credit === VOID ? null : credit;
        due = due === VOID ? null : due;
        proposal = proposal === VOID ? null : proposal;
        remedy = remedy === VOID ? null : remedy;
        accessInfo = accessInfo === VOID ? null : accessInfo;
        time = time === VOID ? null : time;
        this.s8f_1 = type;
        this.t8f_1 = concern;
        this.u8f_1 = raiseIssue;
        this.v8f_1 = fileDispute;
        this.w8f_1 = proposingResolution;
        this.x8f_1 = credit;
        this.y8f_1 = due;
        this.z8f_1 = proposal;
        this.a8g_1 = remedy;
        this.b8g_1 = accessInfo;
        this.c8g_1 = time;
      }
      w9f(type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time) {
        return new (IncidentResponseTypeSerializable())(type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time);
      }
      e8g(type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time, $super) {
        type = type === VOID ? this.s8f_1 : type;
        concern = concern === VOID ? this.t8f_1 : concern;
        raiseIssue = raiseIssue === VOID ? this.u8f_1 : raiseIssue;
        fileDispute = fileDispute === VOID ? this.v8f_1 : fileDispute;
        proposingResolution = proposingResolution === VOID ? this.w8f_1 : proposingResolution;
        credit = credit === VOID ? this.x8f_1 : credit;
        due = due === VOID ? this.y8f_1 : due;
        proposal = proposal === VOID ? this.z8f_1 : proposal;
        remedy = remedy === VOID ? this.a8g_1 : remedy;
        accessInfo = accessInfo === VOID ? this.b8g_1 : accessInfo;
        time = time === VOID ? this.c8g_1 : time;
        var tmp;
        if ($super === VOID) {
          tmp = this.w9f(type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time);
        } else {
          var tmp_0 = $super.w9f;
          var tmp_1 = credit;
          tmp = tmp_0.call(this, type, concern, raiseIssue, fileDispute, proposingResolution, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), due, proposal, remedy, accessInfo, time);
        }
        return tmp;
      }
      toString() {
        var tmp = this.s8f_1.toString();
        var tmp_0 = toString(this.t8f_1);
        var tmp_1 = this.x8f_1;
        return 'IncidentResponseTypeSerializable(type=' + tmp + ', concern=' + tmp_0 + ', raiseIssue=' + this.u8f_1 + ', fileDispute=' + this.v8f_1 + ', proposingResolution=' + this.w8f_1 + ', credit=' + toString(tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) + ', due=' + toString(this.y8f_1) + ', proposal=' + toString(this.z8f_1) + ', remedy=' + toString(this.a8g_1) + ', accessInfo=' + toString(this.b8g_1) + ', time=' + toString(this.c8g_1) + ')';
      }
      hashCode() {
        var result = this.s8f_1.hashCode();
        result = imul(result, 31) + (this.t8f_1 == null ? 0 : this.t8f_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.u8f_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.v8f_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w8f_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.x8f_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.x8f_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.y8f_1 == null ? 0 : this.y8f_1.hashCode()) | 0;
        result = imul(result, 31) + (this.z8f_1 == null ? 0 : this.z8f_1.hashCode()) | 0;
        result = imul(result, 31) + (this.a8g_1 == null ? 0 : this.a8g_1.hashCode()) | 0;
        result = imul(result, 31) + (this.b8g_1 == null ? 0 : this.b8g_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c8g_1 == null ? 0 : this.c8g_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentResponseTypeSerializable()))
          return false;
        if (!this.s8f_1.equals(other.s8f_1))
          return false;
        if (!equals(this.t8f_1, other.t8f_1))
          return false;
        if (!(this.u8f_1 === other.u8f_1))
          return false;
        if (!(this.v8f_1 === other.v8f_1))
          return false;
        if (!(this.w8f_1 === other.w8f_1))
          return false;
        var tmp = this.x8f_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.x8f_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!equals(this.y8f_1, other.y8f_1))
          return false;
        if (!equals(this.z8f_1, other.z8f_1))
          return false;
        if (!equals(this.a8g_1, other.a8g_1))
          return false;
        if (!equals(this.b8g_1, other.b8g_1))
          return false;
        if (!equals(this.c8g_1, other.c8g_1))
          return false;
        return true;
      }
      static v9f(seen0, type, concern, raiseIssue, fileDispute, proposingResolution, credit, due, proposal, remedy, accessInfo, time, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().t9f_1);
        }
        var $this = createThis(this);
        $this.s8f_1 = type;
        if (0 === (seen0 & 2))
          $this.t8f_1 = null;
        else
          $this.t8f_1 = concern;
        if (0 === (seen0 & 4))
          $this.u8f_1 = false;
        else
          $this.u8f_1 = raiseIssue;
        if (0 === (seen0 & 8))
          $this.v8f_1 = false;
        else
          $this.v8f_1 = fileDispute;
        if (0 === (seen0 & 16))
          $this.w8f_1 = false;
        else
          $this.w8f_1 = proposingResolution;
        if (0 === (seen0 & 32))
          $this.x8f_1 = null;
        else
          $this.x8f_1 = credit;
        if (0 === (seen0 & 64))
          $this.y8f_1 = null;
        else
          $this.y8f_1 = due;
        if (0 === (seen0 & 128))
          $this.z8f_1 = null;
        else
          $this.z8f_1 = proposal;
        if (0 === (seen0 & 256))
          $this.a8g_1 = null;
        else
          $this.a8g_1 = remedy;
        if (0 === (seen0 & 512))
          $this.b8g_1 = null;
        else
          $this.b8g_1 = accessInfo;
        if (0 === (seen0 & 1024))
          $this.c8g_1 = null;
        else
          $this.c8g_1 = time;
        return $this;
      }
    }
    initMetadataForClass($, 'IncidentResponseTypeSerializable', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    IncidentResponseTypeSerializableClass = $;
  }
  return IncidentResponseTypeSerializableClass;
}
function serializable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof FileIncident()) {
    tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_FileIncident_getInstance(), _this__u8e3s4.v9e_1, _this__u8e3s4.w9e_1);
  } else {
    if (_this__u8e3s4 instanceof ClientResponse()) {
      tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_ClientResponse_getInstance(), VOID, VOID, _this__u8e3s4.x9e_1, _this__u8e3s4.y9e_1);
    } else {
      if (_this__u8e3s4 instanceof Credit()) {
        tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_Credit_getInstance(), VOID, VOID, VOID, VOID, _this__u8e3s4.k9f_1);
      } else {
        if (_this__u8e3s4 instanceof Remedy()) {
          var tmp1_type = IncidentResponseTypeType_Remedy_getInstance();
          var tmp2_due = _this__u8e3s4.l9f_1;
          var tmp3_credit = _this__u8e3s4.m9f_1;
          tmp = new (IncidentResponseTypeSerializable())(tmp1_type, VOID, VOID, VOID, VOID, tmp3_credit, tmp2_due);
        } else {
          if (_this__u8e3s4 instanceof RemedyHandled()) {
            tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_RemedyHandled_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, VOID, serializable(_this__u8e3s4.a9f_1));
          } else {
            if (_this__u8e3s4 instanceof Handled()) {
              tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_Handled_getInstance(), VOID, VOID, VOID, VOID, _this__u8e3s4.o9f_1);
            } else {
              if (equals(_this__u8e3s4, MoreInfo_instance)) {
                tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_MoreInfo_getInstance());
              } else {
                if (_this__u8e3s4 instanceof Accept()) {
                  tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_Accept_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, serializable(_this__u8e3s4.q9e_1), VOID, _this__u8e3s4.r9e_1);
                } else {
                  if (_this__u8e3s4 instanceof RequestSiteVisit()) {
                    tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_RequestSiteVisit_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4.p9f_1);
                  } else {
                    if (_this__u8e3s4 instanceof Appeal()) {
                      tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_Appeal_getInstance());
                    } else {
                      if (_this__u8e3s4 instanceof NotResponsible()) {
                        tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_NotResponsible_getInstance());
                      } else {
                        if (_this__u8e3s4 instanceof ContractorDispute()) {
                          tmp = new (IncidentResponseTypeSerializable())(IncidentResponseTypeType_ContractorFileDispute_getInstance(), VOID, VOID, VOID, VOID, VOID, VOID, serializable(_this__u8e3s4.d9f_1));
                        } else {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function parseResponse(_this__u8e3s4) {
  try {
    var tmp;
    switch (_this__u8e3s4.s8f_1.b4_1) {
      case 0:
        var tmp1_elvis_lhs = _this__u8e3s4.t8f_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['concern']);
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }

        tmp = new (FileIncident())(tmp_0, _this__u8e3s4.u8f_1);
        break;
      case 1:
        tmp = new (ClientResponse())(_this__u8e3s4.v8f_1, _this__u8e3s4.w8f_1);
        break;
      case 2:
        var tmp2_elvis_lhs = _this__u8e3s4.x8f_1;
        var tmp_1;
        var tmp_2 = tmp2_elvis_lhs;
        if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
          parseResponse$missingFields(_this__u8e3s4, ['credit']);
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }

        tmp = new (Credit())(tmp_1);
        break;
      case 3:
        var tmp3_elvis_lhs = _this__u8e3s4.y8f_1;
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['due']);
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }

        tmp = new (Remedy())(tmp_3, _this__u8e3s4.x8f_1);
        break;
      case 4:
        var tmp4_safe_receiver = _this__u8e3s4.a8g_1;
        var tmp_4;
        if (tmp4_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          var parsed = parseResponse(tmp4_safe_receiver);
          if (!(parsed instanceof Remedy()))
            throw IncidentResponseParseError().f9g(tmp4_safe_receiver, 'IncidentResponseType.Remedy required');
          tmp_4 = parsed;
        }

        var tmp5_elvis_lhs = tmp_4;
        var tmp_5;
        if (tmp5_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['proposal']);
        } else {
          tmp_5 = tmp5_elvis_lhs;
        }

        tmp = new (RemedyHandled())(tmp_5);
        break;
      case 5:
        tmp = new (Handled())(_this__u8e3s4.x8f_1);
        break;
      case 6:
        tmp = MoreInfo_instance;
        break;
      case 7:
        var tmp6_safe_receiver = _this__u8e3s4.z8f_1;
        var tmp_6;
        if (tmp6_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          var parsed_0 = parseResponse(tmp6_safe_receiver);
          if (!isInterface(parsed_0, NeedsApproval()))
            throw IncidentResponseParseError().f9g(tmp6_safe_receiver, 'IncidentResponseType.NeedsApproval required');
          tmp_6 = parsed_0;
        }

        var tmp7_elvis_lhs = tmp_6;
        var tmp_7;
        if (tmp7_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['proposal']);
        } else {
          tmp_7 = tmp7_elvis_lhs;
        }

        var tmp_8 = tmp_7;
        var tmp8_elvis_lhs = _this__u8e3s4.b8g_1;
        var tmp_9;
        if (tmp8_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['accessInfo']);
        } else {
          tmp_9 = tmp8_elvis_lhs;
        }

        tmp = new (Accept())(tmp_8, tmp_9);
        break;
      case 8:
        tmp = new (RequestSiteVisit())(_this__u8e3s4.c8g_1);
        break;
      case 9:
        tmp = Appeal_instance;
        break;
      case 10:
        var tmp9_safe_receiver = _this__u8e3s4.z8f_1;
        var tmp_10;
        if (tmp9_safe_receiver == null) {
          tmp_10 = null;
        } else {
          // Inline function 'kotlin.let' call
          var parsed_1 = parseResponse(tmp9_safe_receiver);
          if (!isInterface(parsed_1, DisputeResolution()))
            throw IncidentResponseParseError().f9g(tmp9_safe_receiver, 'IncidentResponseType.DisputeResultion required');
          tmp_10 = parsed_1;
        }

        var tmp10_elvis_lhs = tmp_10;
        var tmp_11;
        if (tmp10_elvis_lhs == null) {
          parseResponse$missingFields(_this__u8e3s4, ['proposal']);
        } else {
          tmp_11 = tmp10_elvis_lhs;
        }

        tmp = new (ContractorDispute())(tmp_11);
        break;
      case 11:
        tmp = NotResponsible_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof IncidentResponseParseError()) {
      var e = $p;
      if (!e.b9g_1.equals(_this__u8e3s4))
        throw IncidentResponseParseError().f9g(_this__u8e3s4, 'Could not parse response due to inner parsing error: ' + e.toString(), e);
      else
        throw e;
    } else {
      throw $p;
    }
  }
}
var IncidentResponseParseErrorClass;
function IncidentResponseParseError() {
  if (IncidentResponseParseErrorClass === VOID) {
    class $ extends SerializationException() {
      static f9g(struct, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.o10();
        captureStack($this, $this.e9g_1);
        $this.b9g_1 = struct;
        $this.c9g_1 = message;
        $this.d9g_1 = cause;
        delete $this.message;
        delete $this.cause;
        return $this;
      }
      j() {
        return this.c9g_1;
      }
      k() {
        return this.d9g_1;
      }
      get message() {
        return this.j();
      }
      get cause() {
        return this.k();
      }
    }
    initMetadataForClass($, 'IncidentResponseParseError');
    IncidentResponseParseErrorClass = $;
  }
  return IncidentResponseParseErrorClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.k8q_1.f2();
}
function IncidentResponseTypeType$Companion$_anonymous__4uj10o() {
  return createSimpleEnumSerializer('com.crowpay.incidentResponse.IncidentResponseTypeType', values());
}
var IncidentResponseTypeType_FileIncident_instance;
var IncidentResponseTypeType_ClientResponse_instance;
var IncidentResponseTypeType_Credit_instance;
var IncidentResponseTypeType_Remedy_instance;
var IncidentResponseTypeType_RemedyHandled_instance;
var IncidentResponseTypeType_Handled_instance;
var IncidentResponseTypeType_MoreInfo_instance;
var IncidentResponseTypeType_Accept_instance;
var IncidentResponseTypeType_RequestSiteVisit_instance;
var IncidentResponseTypeType_Appeal_instance;
var IncidentResponseTypeType_ContractorFileDispute_instance;
var IncidentResponseTypeType_NotResponsible_instance;
function values() {
  return [IncidentResponseTypeType_FileIncident_getInstance(), IncidentResponseTypeType_ClientResponse_getInstance(), IncidentResponseTypeType_Credit_getInstance(), IncidentResponseTypeType_Remedy_getInstance(), IncidentResponseTypeType_RemedyHandled_getInstance(), IncidentResponseTypeType_Handled_getInstance(), IncidentResponseTypeType_MoreInfo_getInstance(), IncidentResponseTypeType_Accept_getInstance(), IncidentResponseTypeType_RequestSiteVisit_getInstance(), IncidentResponseTypeType_Appeal_getInstance(), IncidentResponseTypeType_ContractorFileDispute_getInstance(), IncidentResponseTypeType_NotResponsible_getInstance()];
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.k8q_1 = lazy(tmp_0, IncidentResponseTypeType$Companion$_anonymous__4uj10o);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  IncidentResponseTypeType_initEntries();
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var IncidentResponseTypeType_entriesInitialized;
function IncidentResponseTypeType_initEntries() {
  if (IncidentResponseTypeType_entriesInitialized)
    return Unit_instance;
  IncidentResponseTypeType_entriesInitialized = true;
  IncidentResponseTypeType_FileIncident_instance = IncidentResponseTypeType().i9g('FileIncident', 0);
  IncidentResponseTypeType_ClientResponse_instance = IncidentResponseTypeType().i9g('ClientResponse', 1);
  IncidentResponseTypeType_Credit_instance = IncidentResponseTypeType().i9g('Credit', 2);
  IncidentResponseTypeType_Remedy_instance = IncidentResponseTypeType().i9g('Remedy', 3);
  IncidentResponseTypeType_RemedyHandled_instance = IncidentResponseTypeType().i9g('RemedyHandled', 4);
  IncidentResponseTypeType_Handled_instance = IncidentResponseTypeType().i9g('Handled', 5);
  IncidentResponseTypeType_MoreInfo_instance = IncidentResponseTypeType().i9g('MoreInfo', 6);
  IncidentResponseTypeType_Accept_instance = IncidentResponseTypeType().i9g('Accept', 7);
  IncidentResponseTypeType_RequestSiteVisit_instance = IncidentResponseTypeType().i9g('RequestSiteVisit', 8);
  IncidentResponseTypeType_Appeal_instance = IncidentResponseTypeType().i9g('Appeal', 9);
  IncidentResponseTypeType_ContractorFileDispute_instance = IncidentResponseTypeType().i9g('ContractorFileDispute', 10);
  IncidentResponseTypeType_NotResponsible_instance = IncidentResponseTypeType().i9g('NotResponsible', 11);
  Companion_getInstance_1();
}
var IncidentResponseTypeTypeClass;
function IncidentResponseTypeType() {
  if (IncidentResponseTypeTypeClass === VOID) {
    class $ extends Enum() {
      static i9g(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'IncidentResponseTypeType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    IncidentResponseTypeTypeClass = $;
  }
  return IncidentResponseTypeTypeClass;
}
function parseResponse$missingFields($this_parseResponse, missingFields) {
  throw IncidentResponseParseError().f9g($this_parseResponse, 'Could not find value for ' + (missingFields.length === 1 ? 'field' : 'fields') + ': ' + joinToString(missingFields));
}
function IncidentResponseTypeType_FileIncident_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_FileIncident_instance;
}
function IncidentResponseTypeType_ClientResponse_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_ClientResponse_instance;
}
function IncidentResponseTypeType_Credit_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_Credit_instance;
}
function IncidentResponseTypeType_Remedy_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_Remedy_instance;
}
function IncidentResponseTypeType_RemedyHandled_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_RemedyHandled_instance;
}
function IncidentResponseTypeType_Handled_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_Handled_instance;
}
function IncidentResponseTypeType_MoreInfo_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_MoreInfo_instance;
}
function IncidentResponseTypeType_Accept_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_Accept_instance;
}
function IncidentResponseTypeType_RequestSiteVisit_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_RequestSiteVisit_instance;
}
function IncidentResponseTypeType_Appeal_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_Appeal_instance;
}
function IncidentResponseTypeType_ContractorFileDispute_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_ContractorFileDispute_instance;
}
function IncidentResponseTypeType_NotResponsible_getInstance() {
  IncidentResponseTypeType_initEntries();
  return IncidentResponseTypeType_NotResponsible_instance;
}
//region block: exports
export {
  IncidentResponseTypeSerializable as IncidentResponseTypeSerializable3r9ni9dqtxaoj,
  IncidentResponseTypeType as IncidentResponseTypeType1fxfyyj6j6wn1,
  parseResponse as parseResponsezbt0whvcgfcx,
  serializable as serializableajawjsrnxxet,
  $serializer_getInstance_1 as $serializer_getInstance11as8uk2vr4gi,
  Companion_getInstance_0 as Companion_getInstance47wfz1otatcx,
  Companion_getInstance_1 as Companion_getInstance6w6jp4uopqll,
};
//endregion

//# sourceMappingURL=serialization.mjs.map
